module.exports = __webpack_public_path__ + "img/in-screen-front_transparent.888073c0.png";